import { useTranslation } from 'react-i18next'
import { noop } from 'lodash'
import { Dialog } from '@machobear/design-system'
import { WizardProvider } from '@/components/modal-wizard-form/wizard-context'
import SponsorWizardFormContent from './content'
import { useSponsoredListingContext } from './context'

const SponsoredListingDialog = ({
  open,
  listingId,
  onClose = noop,
  onSuccess = noop
}: {
  open: boolean
  listingId: string
  onClose: () => void
  onSuccess?: () => void
}) => {
  const { t } = useTranslation()
  const { initialValues, initialStep, isCreateListing } = useSponsoredListingContext()

  const warningModal = {
    id: 'leaveSponsoredListing',
    title: t(
      'b.sponsored_listing.dialog.are_you sure you want to exit?.text',
      'Are you sure you want to exit?'
    ),
    description: t(
      'b.sponsored_listing.dialog.progess_lost.text',
      'Information entered or selected will be lost.'
    ),
    closeButtonLabel: t('b.sponsored_listing.dialog.cancel.text', 'Cancel'),
    confirmButtonLabel: t('b.sponsored_listing.dialog.yes_exit.text', 'Yes, exit')
  }

  return (
    <Dialog
      id="sponsoredListings"
      title={t('common.sponsored_listings', 'Sponsored Listings')}
      onClose={onClose}
      warningModal={warningModal}
      open={open}
      width="content"
    >
      <WizardProvider>
        <SponsorWizardFormContent
          listingId={listingId}
          onSuccess={onSuccess}
          onClose={onClose}
          initialFormValues={initialValues}
          initialStep={initialStep}
          isCreateListing={isCreateListing}
        />
      </WizardProvider>
    </Dialog>
  )
}

export default SponsoredListingDialog
